export const unique = <T>(arr: any[]): T[] =>
	arr.filter((item, index) => arr.indexOf(item) === index)
